import Vue from 'vue';
import App from '@/App.vue';
import router from '@/helpers/router/router';
import store from '@/helpers/store/index';
import axios from '@/helpers/axios/index';

import '@babel/polyfill';
import '@/helpers/plugins/vuetify';
import '@/helpers/moment/index.js';
import 'roboto-fontface/css/roboto/roboto-fontface.css';
import '@mdi/font/css/materialdesignicons.css';
import '@/helpers/analytics/index';

Vue.config.productionTip = false;

// Vue.use(VueAnalytics, {
//   id: 'UA-133880153-3',
//   disableScriptLoader: true,
//   router,
//   autoTracking: {
//     transformQueryString: false,
//     exception: true,
//     screenview: true,
//     skipSamePath: true
//   },
//   debug: {
//     sendHitTask: process.env.NODE_ENV === 'production',
//     enabled: process.env.NODE_ENV !== 'production'
//   }
// });

console.log('Environment', process.env.NODE_ENV);

new Vue({
  router,
  store,
  axios,
  render: h => h(App)
}).$mount('#app');
